import { useContext, useEffect, useState } from "react";
import { abpnClient } from "../../../../Services/AbpnClient";
import { AuthContext } from "../../../Auth/AuthProvider";
import AbpnSpinner from "../../../Shared/Components/AbpnSpinner";
import { AvailableExamination } from "../Models/AvailableExamination";
import AvailableExaminationGroup from "./AvailableExaminationGroup";
import Physician from "../../../Physician/Models/Physician";
import { configService } from "../../../../Services/Config/ConfigService";
import { CertificateStatus } from "../../../Physician/Models/Certificate";

export default function AvailableApplicationGrid() {
    const [availableExams, setAvailableExams] = useState<AvailableExamination[]>([]);
    const [loading, setLoading] = useState<boolean>(true);
    const [physician, setPhysician] = useState<Physician>(null);
    const [notMeeting, setNotMeeting] = useState<boolean>(false);
	const [mailToLink, setMailToLink] = useState<string>(null);
    const authContext = useContext(AuthContext);

    useEffect(() => {
        const loadData = async () => {

           await abpnClient.get<Array<AvailableExamination>>("/api/application/available", authContext)
            .then(exams => {
                setAvailableExams(exams);
            });

            await abpnClient.get<Physician>("/api/physician", authContext)
            .then(physician => {
                setPhysician(physician);
                setNotMeeting(physician.certificates.some(_=>_.ccStatus === 3));
            });
            configService.getConfiguration().then(_ => {
                setMailToLink(_.PhysicianPortalHelp);
            })
            setLoading(false);
        }

        if(loading) loadData();
        
    }, []);

    if (loading) return <AbpnSpinner></AbpnSpinner>;
    return (
        <div>
            {notMeeting && 
                <div className="ml-3 mr-3" >
                    <h3 className="mb-3 text-pp-secondary font-weight-bold">Apply for Exam</h3>
                    <p>ABPN diplomates who are ‘Certified-Not Meeting Requirements’ in the Continuing Certification (CC) Program cannot apply for CC exams or assessments until their status is ‘Certified-Meeting Requirements’. </p>
                    <p>Outstanding CC activities should be updated in the Physician Portal.  Once CC activities are completed, they can apply. If you have any questions, contact ABPN at <a href={mailToLink}>questions@abpn.org</a>.</p>
                </div>}
            {!notMeeting &&
            <div className="ml-3 mr-3" >
                <h3 className="mb-3 text-pp-secondary font-weight-bold">Apply for Exam</h3>
                <AvailableExaminationGroup
                    key="Article Assessment Continuing Certification Applications"
                    title="Article Assessment Continuing Certification Applications"
                    examinations={availableExams.filter(_ => _.isMoc && _.isArticleBased)}
                    currentCCEnrollment={null} 
                    isFullyLapsed={physician.certificates.every(_ => _.certificateStatus == CertificateStatus.Inactive)}/>
                <AvailableExaminationGroup
                    key="Continuing Certification Applications"
                    title="Continuing Certification Applications"
                    examinations={availableExams.filter(_ => _.isMoc && !_.isArticleBased)} 
                    currentCCEnrollment={physician.currentCCEnrollment} 
                    isFullyLapsed={false}/>
                <AvailableExaminationGroup
                    key="Specialty Certification Applications"
                    title="Specialty Certification Applications"
                    examinations={availableExams.filter(_ => !_.isMoc && _.isPrimary)} 
                    currentCCEnrollment={null} 
                    isFullyLapsed={false}/>
                <AvailableExaminationGroup
                    key="Subspecialty Certification Applications"
                    title="Subspecialty Certification Applications"
                    examinations={availableExams.filter(_ => !_.isMoc && !_.isPrimary)} 
                    currentCCEnrollment={null} 
                    isFullyLapsed={false}/>
            </div>}
        </div>
    );
}